import React, { useEffect } from 'react';
import { Card, Table, Rate, Tag, Typography, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeedbacks } from '../../redux/thunks/adminThunks';
import {
  selectFeedbacks,
  selectFeedbackTotal,
  selectFeedbackStatus,
  selectFeedbackError,
} from '../../redux/selectors/adminSelectors';

export default function Feedbacks() {
  const dispatch = useDispatch();

  const feedbacks = useSelector(selectFeedbacks);
  const total = useSelector(selectFeedbackTotal);
  const status = useSelector(selectFeedbackStatus);
  const error = useSelector(selectFeedbackError);

  const isLoading = status === 'loading';

  useEffect(() => {
    dispatch(fetchFeedbacks());
  }, [dispatch]);


  

const columns = [
  {
    title: 'User',
    dataIndex: 'userName',
    key: 'userName',
    render: (userName) => (
      <Typography.Text strong>
        {userName || 'Unknown user'}
      </Typography.Text>
    ),
  },

  {
    title: 'Role',
    dataIndex: 'userRole',
    key: 'userRole',
    render: (role) => (
      <Tag color={role === 'doctor' ? 'blue' : 'green'}>
        {role || 'unknown'}
      </Tag>
    ),
  },

  {
    title: 'Rating',
    dataIndex: 'rating',
    key: 'rating',
    render: (rating) => <Rate disabled value={rating} />,
  },

  {
    title: 'Message',
    dataIndex: 'message',
    key: 'message',
  },

  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (date) =>
      date ? new Date(date).toLocaleString('fr-FR') : '-',
  },
];

  return (
    <Card
      title={`Feedbacks (${total})`}
      extra={
        <Button
          icon={<ReloadOutlined />}
          onClick={() => dispatch(fetchFeedbacks())}
        >
          Refresh
        </Button>
      }
    >
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <Table
        rowKey="id"
        loading={isLoading}
        columns={columns}
        dataSource={feedbacks}
        pagination={{ pageSize: 8 }}
      />
    </Card>
  );
}